import type { GridColumnVisibilityModel } from '@mui/x-data-grid';

/** Columns that must stay visible in the project search grid (ID, Title, PI). */
export const PROJECT_GRID_ALWAYS_VISIBLE_FIELDS = ['projectLabel', 'title', 'user'] as const;

/**
 * Ensures ID, Title, and PI cannot be hidden via the Columns panel or group toggles.
 */
export function enforceProjectGridNonHideableColumns(model: GridColumnVisibilityModel): GridColumnVisibilityModel {
  const next = { ...model };
  for (const field of PROJECT_GRID_ALWAYS_VISIBLE_FIELDS) {
    next[field] = true;
  }
  return next;
}

export type ProjectGridVisibilityGroupId = 'projectDetails' | 'samples' | 'lastChanged';

/** Field sets toggled by the toolbar “Groups” menu (must match column `field` names). */
export const PROJECT_GRID_VISIBILITY_GROUPS: readonly {
  id: ProjectGridVisibilityGroupId;
  label: string;
  fields: readonly string[];
}[] = [
  {
    id: 'projectDetails',
    label: 'Project Details',
    fields: [
      'projectStatus',
      'faculty',
      'staff',
      'materials',
      'piInstitution',
      'type',
      'piState',
      'startDate',
      'endDate',
    ],
  },
  {
    id: 'samples',
    label: 'Samples',
    fields: ['totalNbSamplesRequested', 'nbSamplesShipped', 'totalNbSamples', 'nbSamplesDue'],
  },
  {
    id: 'lastChanged',
    label: 'Last Changed',
    fields: ['lastChangedDate', 'lastChangedBy'],
  },
];
